import { createParser } from "../create-parser";
/**
 * The parser configuration for common background properties
 */

var config = {
  bg: {
    property: "background",
    scale: "colors"
  },
  bgColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  background: {
    property: "background",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundBlendMode: true,
  bgImage: {
    property: "backgroundImage"
  },
  bgImg: {
    property: "backgroundImage",
    deprecated: true,
    replacement: "bgImage"
  },
  bgBlendMode: {
    property: "backgroundBlendMode"
  },
  bgSize: {
    property: "backgroundSize"
  },
  bgPosition: {
    property: "backgroundPosition"
  },
  bgPos: {
    property: "backgroundPosition",
    deprecated: true,
    replacement: "bgPosition"
  },
  bgRepeat: {
    property: "backgroundRepeat"
  },
  bgAttachment: {
    property: "backgroundAttachment"
  }
};
/**
 * The prop types for background properties listed above
 */

/**
 * Create the parser for the config object
 */

export var background = createParser(config);